import {useState, useCallback} from 'react';
import {every} from 'lodash';
import useGetSyncPromise from '../utils/react/useGetSyncPromise';
import useBeforeUnloadConfirmation from '../utils/react/useBeforeUnloadConfirmation';

export type AddSavePromise = <T>(promise: Promise<T>) => Promise<T>;

export default function useIsSaved(): [boolean, AddSavePromise] {
    const [promises, setPromises] = useState<Promise<any>[]>([]);

    const addSavePromise: AddSavePromise = useCallback(
        promise => {
            setPromises([...promises, promise]);
            return promise;
        },
        [promises]
    );

    const getSyncPromise = useGetSyncPromise();
    const isSaved = every(promises.map(promise => getSyncPromise(promise)[2]));

    useBeforeUnloadConfirmation(!isSaved);

    return [isSaved, addSavePromise];
}
